export const genratreMapScript = (key) => {
  var s = document.createElement('script');
  s.setAttribute(
    'src',
    'https://maps.googleapis.com/maps/api/js?key=' +
      key +
      '&libraries=places&language=en'
  );
  document.head.appendChild(s);
};
